var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArzBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 698.3 999.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f5bd18;\n      }\n\n      .cls-2 {\n        fill: #b4d569;\n      }\n\n      .cls-3 {\n        fill: #27b173;\n      }\n\n      .cls-4 {\n        opacity: .72;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M254.21,717.51l-.37-.33L3.53,493.9l.33-.37L444.09,0l.37,.33,250.31,223.27L254.21,717.51ZM4.94,493.82l249.19,222.27L693.35,223.68,444.17,1.41,4.94,493.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.41,867.86L0,640.93l2-2.24L443.89,143.3l2.24,2,252.17,224.93-2,2.24L254.41,867.86ZM8.47,640.45l245.45,218.95,435.9-488.68-245.45-218.94L8.47,640.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 181.69,
    y: 310.99,
    width: 334.91,
    height: 660.84,
    transform: "translate(515.55 -69.66) rotate(41.73)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArzBg);
export default __webpack_public_path__ + "static/media/arz-bg.b7dfb2a191ccb339714775db15809fb4.svg";
export { ForwardRef as ReactComponent };